import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ManageProducts = () => {
  const [products, setProducts] = useState([]);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [link, setLink] = useState('');
  const [image, setImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editId, setEditId] = useState(null);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(window.API_URL + '/products');
      setProducts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    const token = localStorage.getItem('portalToken') || localStorage.getItem('adminToken');
    const formData = new FormData();
    formData.append('title', title);
    formData.append('desc', desc);
    formData.append('link', link);
    if (image) formData.append('image', image);

    try {
      if (editId) {
        await axios.put(`${window.API_URL}/products/${editId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        });
      } else {
        await axios.post(window.API_URL + '/products', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        });
      }
      fetchProducts();
      resetForm();
    } catch (err) {
      console.error(err);
      alert(`Error ${editId ? 'updating' : 'adding'} product`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setTitle('');
    setDesc('');
    setLink('');
    setImage(null);
    setEditId(null);
    const fileInput = document.getElementById('product-image-input');
    if (fileInput) fileInput.value = '';
  };

  const handleEdit = (product) => {
    setEditId(product._id);
    setTitle(product.title);
    setDesc(product.desc);
    setLink(product.link || '');
    setImage(null);
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem('portalToken') || localStorage.getItem('adminToken');
    try {
      await axios.delete(`${window.API_URL}/products/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchProducts();
    } catch (err) {
      console.error(err);
      alert('Error deleting product');
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8 text-gray-800">Manage Products</h1>
      
      {/* Add/Edit Form */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-[#f06600]">
            {editId ? 'Edit Product' : 'Add New Product'}
          </h2>
          {editId && (
            <button onClick={resetForm} className="text-sm text-gray-500 hover:text-gray-700 underline">
              Cancel Edit
            </button>
          )}
        </div>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input type="text" placeholder="Product Title" value={title} onChange={e => setTitle(e.target.value)} required className="border p-2 rounded" />
          <input type="text" placeholder="Product Link (Optional)" value={link} onChange={e => setLink(e.target.value)} className="border p-2 rounded" />
          <textarea placeholder="Description" value={desc} onChange={e => setDesc(e.target.value)} required className="border p-2 rounded md:col-span-2 h-24"></textarea>
          <input type="file" id="product-image-input" onChange={e => setImage(e.target.files[0])} required={!editId} className="border p-2 rounded md:col-span-2" accept="image/*" />
          <button type="submit" disabled={isSubmitting} className={`md:col-span-2 text-white py-2 rounded-lg font-bold transition ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#f06600] hover:bg-[#d05800]'}`}>
            {isSubmitting ? (editId ? 'Updating...' : 'Adding...') : (editId ? 'Update Product' : 'Add Product')}
          </button>
        </form>
      </div>

      {/* Products List */}
      <div className="bg-white p-6 rounded-xl shadow-md">
        <h2 className="text-xl font-semibold mb-4 text-gray-700">Current Products</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map(product => (
            <div key={product._id} className="border rounded-lg overflow-hidden flex flex-col">
              <img src={`${window.API_URL}/uploads/${product.image}`} alt={product.title} className="w-full h-48 object-cover border-b-4 border-[#f06600]" />
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-bold text-xl mb-2">{product.title}</h3>
                <p className="text-gray-600 text-sm mb-4 flex-1">{product.desc}</p>
                {product.link && <a href={product.link} target="_blank" rel="noreferrer" className="text-blue-500 hover:underline mb-4 text-sm break-all">{product.link}</a>}
                <div className="flex gap-2 mt-auto">
                  <button onClick={() => handleEdit(product)} className="w-1/2 py-2 bg-blue-100 text-blue-600 font-semibold rounded hover:bg-blue-200 transition">Edit</button>
                  <button onClick={() => handleDelete(product._id)} className="w-1/2 py-2 bg-red-100 text-red-600 font-semibold rounded hover:bg-red-200 transition">Delete</button>
                </div>
              </div>
            </div>
          ))}
          {products.length === 0 && <p className="text-gray-500 col-span-full">No products found.</p>}
        </div>
      </div>
    </div>
  );
};

export default ManageProducts;
